export default __webpack_public_path__ + "static/media/linkedin.1f272541.svg";